import { render, staticRenderFns } from "./DistributionDetails.vue?vue&type=template&id=7266797c&"
import script from "./DistributionDetails.vue?vue&type=script&lang=js&"
export * from "./DistributionDetails.vue?vue&type=script&lang=js&"
import style0 from "./DistributionDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports